import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../APIConfig";
import AuthAPI from "../AuthAPI";

export const _User = {
    pagination: cursor => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url(`/user/module-photo-albums/pagination`),
            {
                token: AuthAPI.getUserAccessToken(),
                cursor: cursor,
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    getFullUserEventInfo: (event_id, type) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url(`/user/module-photo-albums/get-full-event-info`),
            {
                token: AuthAPI.getUserAccessToken(),
                event_id: event_id,
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    save: event => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/user/module-photo-albums/save`),
            event,
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    }
}